<template>
  <div class='mt-1'>
    <b-modal
      ref='ventilationIdentifiedModal'
      id='ventilationIdentifiedModal'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='xl'
      @show='showModal()'
      :no-close-on-esc='loading'
      :no-close-on-backdrop='loading'
    >
      <b-overlay
        :show='lookingTermsOfUse'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
      >
        <section class='modal-font-family'>
          <section class='d-flex justify-content-between align-items-start  w-100 mb-5 mt-1'>
            <section>
              <span class='title'>Condição de ventilação do ambiente de trabalho de forma geral</span><br/>
              <span class='sub-title'>Selecione uma das opções abaixo</span>
            </section>
            <b-icon
              @click='closeModal()'
              class='cursor-pointer'
              font-scale='2.2'
              icon='x'
              color='#022245'
            >
            </b-icon>
          </section>

          <section class='w-100'>
            <b-form-radio-group
              class='container-level'
              v-model='sector.ventilationWorkEnvironmentGeneral'
            >
              <section
                class=' level'
                :class="sector.ventilationWorkEnvironmentGeneral === 1 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='1'>
                  <span class='level-text-radio'>
                    Nível de Ventilação Baixo
                  </span>
                </b-form-radio>

                <hr />

                <section class='level-img'>
                  <img width='25' class='mr-3' height='25' src='../../../../../assets/images/filledVentilation.svg'
                       alt='' />
                  <img width='25' class='mr-3' height='25' src='../../../../../assets/images/ventilation.svg' alt='' />
                  <img width='25' height='25' src='../../../../../assets/images/ventilation.svg' alt='' />
                </section>

                <section>
                  <p class='level-text-orintation'>
                    Ambiente fechado, com muitas paredes, poucas janelas ou aberturas, onde o ar circula pouco e tem dificuldade para se renovar.
                  </p>
                </section>
              </section>

              <section
                class=' level'
                :class="sector.ventilationWorkEnvironmentGeneral === 2 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='2'>
                  <span class='level-text-radio'>
                    Nível de Ventilação Médio
                  </span>
                </b-form-radio>

                <hr />

                <section class='level-img'>
                  <img width='25' class='mr-3' height='25' src='../../../../../assets/images/filledVentilation.svg'  alt='' />
                  <img width='25' class='mr-3' height='25' src='../../../../../assets/images/filledVentilation.svg' alt='' />
                  <img width='25' height='25' src='../../../../../assets/images/ventilation.svg' alt='' />
                </section>

                <section>
                  <p class='level-text-orintation'>
                    Ambiente fechado, com muitas paredes, mas com janelas, portas, aberturas ou equipamentos que ajudam na circulação do ar.
                  </p>
                </section>
              </section>

              <section
                class=' level'
                :class="sector.ventilationWorkEnvironmentGeneral === 3 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='3'>
                  <span class='level-text-radio'>
                    Nível de Ventilação Alto
                  </span>
                </b-form-radio>

                <hr />

                <section class='level-img'>
                  <img width='25' class='mr-3' height='25' src='../../../../../assets/images/filledVentilation.svg'  alt='' />
                  <img width='25' class='mr-3' height='25' src='../../../../../assets/images/filledVentilation.svg' alt='' />
                  <img width='25' height='25' src='../../../../../assets/images/filledVentilation.svg' alt='' />
                </section>

                <section>
                  <p class='level-text-orintation'>
                    Ambiente aberto ou quase aberto, com poucas paredes ou barreiras, onde o ar circula livremente de forma natural.
                  </p>
                </section>
              </section>

            </b-form-radio-group>
          </section>

          <section class='disclaimer mt-4'>
            <b-icon
              class='disclaimer-icon'
              font-scale='1.4'
              icon='exclamation-triangle-fill'
            >
            </b-icon>
            <p class='disclaimer-text'>
              <span class='disclaimer-title'>Aviso: </span>a presença de ar-condicionado não significa, necessariamente, que há renovação de ar no ambiente, pois muitos sistemas apenas circulam o ar interno. Para esta avaliação, considere como ventilação artificial/mecânica apenas quando houver circulação, renovação, insuflação ou exaustão efetiva do ar.
            </p>
          </section>

          <section class='mt-4'>
            <b-alert show variant='danger' :class='{ hidden: !error }'>
              {{ error }}<br />
            </b-alert>
          </section>

          <section class='d-flex justify-content-between mt-4 w-100'>
            <button
              class='btn-cancel'
              @click='closeModal()'
            >
              <span>Cancelar</span>
            </button>

            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class=''
              style='width: 66%'
            >
              <button
                class='w-100 btn-add'
                style='width: 100%'
                @click='update()'
              >
                <span> Finalizar condições de ventilação </span>
              </button>
            </b-overlay>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h6 class='text-primary'>Buscando cargo...</h6>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { optionsVentilationIdentified } from '@/mocks/optionsVentilationIdentified'

export default {
  name: 'VentilationIdentifiedModal',
  components: {},
  props: {
    sectorId: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      lookingTermsOfUse: false,
      titles: {
        1: `Condição de ventilação do ambiente de trabalho de forma geral`,
        2: `Condição de ventilação instalada e específica para o processo produtivo`
      },
      ventilation: 2,
      ventilationConditionsEnvironmentWorkGeneralForm: 1,
      specificInstalledVentilationConditionsProductionProcess: 3,
      sector: {
        ventilationWorkEnvironmentGeneral: null,
      },
      optionsVentilationIdentified: []
    }
  },
  async mounted() {
    try {

    } catch (e) {
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    disabled() {
      return !(this.sector.ventilationIdentified)
    },
    error() {
      return this.$store.getters['access/error']
    },
  },
  methods: {
    ...mapActions('sector', {
      handleCreate: 'handleCreate',
      handleGet: 'handleGet',
      handleUpdade: 'handleUpdade'
    }),
    async closeModalVentilationIdentified() {
      try {
        this.$bvModal.hide('ventilationIdentified')
      } catch (e) {

      }
    },

    async showModal() {
      try {
        await this.$store.dispatch('access/updateError', '')
        Object.assign(this.optionsVentilationIdentified, optionsVentilationIdentified)
        this.optionsVentilationIdentified = optionsVentilationIdentified
        this.sector = {
          ventilationWorkEnvironmentGeneral: null,
        }
        console.log(this.sectorId)
        if (this.sectorId) {
          await this.get()
        }
      } catch (e) {

      }
    },

    async update() {
      try {
        if(!this.sector.ventilationWorkEnvironmentGeneral){
          await this.$store.dispatch('access/updateError', 'Selecione a condição de ventilação do ambiente de trabalho de forma geral')
          return
        }
        this.loading = true
        const { data, status } = await this.handleUpdade(this.sector)
        this.loading = false
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeModal()
        this.$emit('update')
      } catch (e) {
        this.$bvToast.toast('Não foi possível atualizar a condição de ventilação do ambiente de trabalho de forma geral e a condição de ventilação instalada e específica para o processo produtivo, verifique os dados e tente novamente.', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 10000
        })
        this.loading = false
        this.closeModal()
        this.$emit('update')
      }
    },

    async get() {
      try {
        this.lookingTermsOfUse = true
        const { data, status } = await this.handleGet(this.sectorId)
        const { sector } = data
        this.sector = sector
        this.lookingTermsOfUse = false
      } catch (e) {
      }
    },

    closeModal() {
      if (this.loading) {
        return
      }
      this.$bvModal.hide('ventilationIdentifiedModal')
    }
  },
  created() {
  }
}
</script>
<style lang='scss' scoped>
.btn-cancel {
  background: transparent !important;
  border-radius: 4px !important;
  border: 1px solid var(--navy-blue) !important;
  width: 32%!important;
  padding: 6px 0;
  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 4px !important;
  border: 1px solid var(--navy-blue) !important;
  width: 66%;
  padding: 6px 0;
  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.modalVentilacao {
  display: inline-block;
  margin: 10px;
  justify-content: center;
  cursor: pointer;

  .img-caption {
    text-align: center;

    .caption {
      font-size: 13px;
      text-align: center;
      max-width: 230px;
    }
  }
}

.ventilationIdentified {
  .label {
    font-size: 18px;
    font-weight: 700;
  }

  .btn {
    width: 100%;
    min-height: 48px;
    border: 1px solid var(--border-input);
    border-radius: 4px;
    outline: none !important;
    text-align: left;
  }

}

.title{
  font-size: 22px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: var(--navy-blue)
}
.sub-title{
  font-size: 16px;
  font-weight: 400;
  line-height: 19.5px;
  text-align: left;
  color: #808080;
}

.ventilation-level-not-selected {
  border: 1px solid #D9D9D9;
  .level-text-radio {
    font-size: 14px;
    font-weight: 700;
    color: #808080;
  }
}
.ventilation-level-selected {
  border: 1px solid #022245;
  .level-text-radio {
    font-size: 14px;
    font-weight: 700;
    color: #022245;
  }
}

.level {
  border-radius: 4px;
  padding: 10px;
  margin: 5px;
  //width: 32%;
  .level-img {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
  }

  .level-text-orintation {
    font-size: 14px;
    font-weight: 400;

  }
}

hr {
  background-color: #D9D9D9;
}

.disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border-left: 4px solid #F9A825;
  background: #FFF8E1;

  .disclaimer-icon {
    flex-shrink: 0;
    color: #F9A825;
  }

  .disclaimer-text {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: #262626;

    .disclaimer-title {
      font-weight: 700;
    }
  }
}

.container-level{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(32%, auto));
}
</style>
